import { Stack, Typography } from '@mui/material';
import * as React from 'react';

import { SideNavProps } from '~ui-components/components/molecules/side-nav';

export const dataImportNavItemKeys = {
	SHAPEFILE: 'SHAPEFILE',
	CSV: 'CSV',
	TAB: 'TAB',
	GEOJSON: 'GEOJSON',
	KML: 'KML',
	FILEGDB: 'FILEGDB',
	GEOTIFF: 'GEOTIFF',
	WMS: 'WMS',
} as const;

export type DataImportSideNavProps = Omit<SideNavProps, 'navItems'>;

export function DataImportSideNav(): React.JSX.Element {
	return (
		<Stack spacing={3}>
			<div>
				<Typography variant="body2" color="text.secondary" gutterBottom>
					Upload from file
				</Typography>
			</div>

			<div>
				<Typography variant="body2" color="text.secondary" gutterBottom>
					Connect external source
				</Typography>
			</div>
		</Stack>
	);
}
